const GALLERY_TYPE = 'wix-draft-plugin-gallery';
const getDefaultComponentData = (defaultLayout = GalleryLayout.GRID)=>({
        items: [],
        styles: {
            galleryLayout: defaultLayout,
            cropping: CropFit.CROP,
            spacing: 4,
            // Grid
            gridItemWidth: 386,
            gridItemHeight: 338,
            // Masonry
            masonryRowHeight: 270,
            gallerySizeType: 'px',
            gallerySizePx: 300,
            galleryMargin: 0,
            oneRow: false,
            cubeRatio: 1,
            galleryThumbnailsAlignment: 'bottom',
            isVertical: false,
            imageMargin: 20,
            thumbnailSpacings: 0,
            cubeType: 'fill',
            enableInfiniteScroll: true,
            titlePlacement: 'SHOW_ON_HOVER',
            allowHover: false,
            itemClick: 'link',
            fullscreen: false,
            showArrows: false,
            gridStyle: 1,
            loveButton: false,
            allowSocial: false,
            allowDownload: false,
            mobileSwipeAnimation: 'NO_EFFECT',
            thumbnailSize: 120,
            gotStyleParams: true,
            showVideoPlayButton: true,
            videoPlay: 'onClick',
            innerAlignment: 'left'
        },
        config: {
            alignment: 'center',
            size: 'content',
            layout: 'small',
            spacing: 0
        }
    });
export var GalleryLayout;
(function(GalleryLayout) {
    GalleryLayout[GalleryLayout["MASONRY"] = 1] = "MASONRY";
    GalleryLayout[GalleryLayout["GRID"] = 2] = "GRID";
})(GalleryLayout || (GalleryLayout = {}));
export var CropFit;
(function(CropFit) {
    CropFit["CROP"] = 'crop';
    CropFit["FIT"] = 'fit';
})(CropFit || (CropFit = {}));
export { GALLERY_TYPE, getDefaultComponentData };
